module.exports = "<div class=\"wrapper wrapper-sm\">\n    <section class=\"page\">\n        <div class=\"page-content\">\n            <div class=\"box p1 lg-pxl bb1 mbxl\">\n                <div class=\"box-body\">\n                    <h1 class=\"h2 mt0\"><span class=\"page-heading h4 text-upper\">503 Error</span><br>Service Currently Unavailable</h1>\n                    <p class=\"mb0\">The website store is currently down for maintenance. Please check back shortly.</p>\n                </div>\n            </div>\n        </div>\n    </section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/templates/503.html
// module id = 102
// module chunks = 0